
import { useApiStore } from "@/stores/apiStore";
import { defineComponent, onMounted, Ref } from "vue";
import moment from "moment-timezone";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/authStore";
import { FormatBytes } from "@/utils/Utilities";
import { IListSiteTableFormatResponseDTO } from "@/types/sites";
export default defineComponent({
	name: "imdex-manage-sites",
	setup() {
		const api = useApiStore();
		const authStore = useAuthStore();
		const router = useRouter();
		const formatBytes = FormatBytes;
		const { user }: { user: Ref<AuthUser | null> } = storeToRefs(authStore);
		onMounted(() => {
			const u = user.value; // eslint-disable-next-line
			if (
				u!.globalRole.name != "Administrator" &&
				u!.globalRole.name != "System Administrator"
			) {
				router.push("/ssa");
			}
		});
		return { api, moment, authStore, formatBytes };
	},
	data() {
		return {
			tableLoading: true,
			sites: [] as any[],
			totalUsers: 0,
			containerSize: 400000000
		};
	},
	async mounted() {
		const { data }: { data: IListSiteTableFormatResponseDTO } =
			await this.api.get("/site/table");

		const mappedData = data.sitesList.map((item: any) => {
			return {
				color: item.color,
				country: item.country,
				size: item.siteUploadsSize,
				assigned_users: item.assignedUsers,
				created_at: item.createdAt,
				...item
			};
		});
		this.sites = mappedData;
		this.tableLoading = false;
		this.totalUsers = data.totalUsersCount;
		this.containerSize = data.containerSizeLimit;
	},
	computed: {
		tableData(): { columns: string[]; tableData: AuthUser[] } {
			return {
				columns: ["name", "country", "size", "assigned_users", "created_at"],
				tableData: this.sites
			};
		}
	}
});
